import {
  ContentfulBasicPageQuery,
  ContentfulBasicPageQueryVariables
} from "@outschool/gql-frontend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

const CONTENTFUL_BASIC_PAGE_QUERY = gql`
  query ContentfulBasicPage(
    $slug: String!
    $locale: String
    $preview: Boolean!
  ) {
    contentfulBasicPageCollection(
      limit: 1
      skip: 0
      where: { slug: $slug }
      preview: $preview
      locale: $locale
    ) {
      items {
        title
        publishedAt
        headerImage {
          url(transform: { width: 1000 })
          width
          height
        }
        body {
          json
          links {
            assets {
              block {
                sys {
                  id
                }
                url(
                  transform: {
                    quality: 100
                    width: 2048
                    height: 1536
                    format: JPG
                  }
                )
                title
                width
                height
                description
              }
            }
          }
        }
      }
    }
  }
`;

export default function useFetchContentfulBasicPage({
  slug,
  locale
}: {
  slug: string | undefined;
  locale?: string;
}) {
  const response = useQueryWithPreviousData<
    ContentfulBasicPageQuery,
    ContentfulBasicPageQueryVariables
  >(CONTENTFUL_BASIC_PAGE_QUERY, {
    variables: { slug: slug!, preview: false, locale },
    skip: !slug
  });

  return response?.data?.contentfulBasicPageCollection?.items?.[0];
}
